import React, { useState, useEffect } from "react";
import { FormatAmount, FormatCreditCard } from '../common/functions';
import moment from 'moment';
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { CircularProgress } from "@material-ui/core";
import variablesDomain from '../../helpers/variablesDomain';

export default function ModalDetallesTarjeta(props) {
    const [copiar, setCopiar] = useState(false);
    const [showModal, setShowModal] = useState(props.open);
    const [showCVC, setShowCVC] = useState(false);
    const [loadingShowDetails, setLoadingShowDetails] = useState(false);

    const [color, setColor] = useState("");
    const [colorText, setColorText] = useState("");

    useEffect(() => {
        setColor(
            props.data.state === "ACTIVE"
                ? "border-green-500"
                : props.data.state === "INACTIVE"
                    ? "border-red-500"
                    : props.data.state === "FROZEN"
                        ? "border-yellow-500"
                        : null
        );
        setColorText(
            props.data.state === "ACTIVE"
                ? "text-green-500"
                : props.data.state === "INACTIVE"
                    ? "text-red-500"
                    : props.data.state === "FROZEN"
                        ? "text-yellow-500"
                        : null
        );
    }, []);

    useEffect(() => {
        if (copiar === true) {
            const timer = setTimeout(() => {
                setCopiar(false);
            }, 2500);
        }
    }, [copiar]);

    const title = `REF-${props.data?.pk || ''}`;

    function formatDate(x) {
        let date = moment(x).format('DD/MM/YYYY HH:mm A');
        return date;
    }

    const formatEstadoTarjeta = (estado) => {
        switch (estado) {
            case "ACTIVE":
                return "ACTIVA";
            case "INACTIVE":
                return "INACTIVA";
            case "FROZEN":
                return "CONGELADA";
            default:
                return estado;
        }
    };

    const copy = (text) => {
        var id = "el-id-del-textarea";
        var existsTextarea = document.getElementById(id);

        if (!existsTextarea) {
            var textarea = document.createElement("textarea");
            textarea.id = id;
            textarea.style.position = 'fixed';
            textarea.style.top = 0;
            textarea.style.left = 0;
            textarea.style.textTransform = "lowercase";
            textarea.style.width = '1px';
            textarea.style.height = '1px';
            textarea.style.padding = 0;
            textarea.style.border = 'none';
            textarea.style.outline = 'none';
            textarea.style.boxShadow = 'none';
            textarea.style.background = 'transparent';
            document.querySelector("body").appendChild(textarea);
            existsTextarea = document.getElementById(id);
        }

        existsTextarea.value = text;
        existsTextarea.select();

        try {
            var status = document.execCommand('copy');
            if (!status) {
                console.error("No se pudo copiar el texto");
            } else {
                setCopiar(true);
            }
        } catch (err) {
            console.error("Error al copiar", err);
        }
    }

    return (
        <>
            {showModal ? (
                <>
                    <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-pop-up my-6 mx-auto max-w-md">
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                <button
                                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                    onClick={() => props.modal(false)}
                                >
                                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                        ×
                                    </span>
                                </button>
                                <div className="relative px-6 pb-1 flex-auto">
                                    {copiar && <div className="copiado-modal">Copiado</div>}

                                    <h3 className="text-3xl font-bold text-trixel-popup centrar-contenido">
                                        {title}
                                    </h3>
                                    <hr />

                                    <div className="justify-between flex-row">
                                        <div className='flex flex-row items-center py-3 justify-between'>
                                            <div className='flex flex-row items-center' style={{ marginLeft: '10px' }}>
                                                <div className="flex items-center justify-center" style={{ width: 50, marginRight: 20 }}>
                                                    <img
                                                        className="object-contain"
                                                        style={{ maxWidth: '100%', maxHeight: '30px' }}
                                                        src={require('../../assets/card/VISA.png')}
                                                        alt="Logo Visa"
                                                    />
                                                </div>
                                                <div>
                                                    <p className='text-gray-700 text-xs'>Tarjeta</p>
                                                    <p className="text-gray-700 text-base">Visa</p>
                                                </div>
                                            </div>
                                            <div className={`${color}`} style={{ borderWidth: 1.5 }}>
                                                <p className={`${colorText} px-1 py-1 text-sm m-0`}>
                                                    {formatEstadoTarjeta(props.data.state)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="my-4 py-2 mb-1 text-gray-600 text-lg leading-relaxed border-solid text-gray-700 rounded">
                                        <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                Número de Tarjeta
                                            </p>
                                            <button onClick={() => copy(props.data?.masked_pan)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                {props.data?.masked_pan}
                                            </button>
                                        </div>

                                        <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                Nombre en Tarjeta
                                            </p>
                                            <button onClick={() => copy(props.data.card_name)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                {props.data.card_name || 'N/A'}
                                            </button>
                                        </div>
                                        <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                Precio Tarjeta
                                            </p>
                                            <button onClick={() => copy(props.data.price_card)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                <span>
                                                    {`${FormatAmount(props.data.price_card, 1)}`}
                                                    <span style={{ fontSize: 9 }}>{`${FormatAmount(props.data.price_card, 2)}`}</span>
                                                </span>
                                            </button>
                                        </div>
                                        <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                IVA Tarjeta
                                            </p>
                                            <button onClick={() => copy(props.data.iva_card)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                <span>
                                                    {`${FormatAmount(props.data.iva_card, 1)}`}
                                                    <span style={{ fontSize: 9 }}>{`${FormatAmount(props.data.iva_card, 2)}`}</span>
                                                </span>
                                            </button>
                                        </div>
                                        <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                País
                                            </p>
                                            <button onClick={() => copy(props.data.price_card)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                {props.data?.country || 'N/A'}
                                            </button>
                                        </div>
                                        {/*   <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                Fecha Expiración
                                            </p>
                                            <button onClick={() => copy(props.data.expiration_date)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                { moment(props.data.expiration_date).format('YYYY-MM-DD')|| 'MM/AA'}
                                            </button>
                                        </div> */}


                                        {/*                                         <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                Saldo Disponible
                                            </p>
                                            <button onClick={() => copy(props.data.balance)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                <span>
                                                    {`${FormatAmount(props.data.balance || props.data.available_balance, 1)}`}
                                                    <span style={{ fontSize: 9 }}>{`${FormatAmount(props.data.balance || props.data.available_balance, 2)}`}</span>
                                                </span>
                                            </button>
                                        </div>

                                        <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-6/12 text-left">
                                                Saldo Máximo
                                            </p>
                                            <button onClick={() => copy(props.data.max_balance)} className="rounded-full text-sm w-6/12 text-right button-outline-off copy-cursor">
                                                <span>
                                                    {`${FormatAmount(props.data.max_balance, 1)}`}
                                                    <span style={{ fontSize: 9 }}>{`${FormatAmount(props.data.max_balance, 2)}`}</span>
                                                </span>
                                            </button>
                                        </div> */}

                                        <hr />

                                        <div className="flex items-center px-1 leading-7 margin-10px margin-top-10px">
                                            <p className="rounded-full mr-4 text-sm w-2/3 text-left">
                                                Token de Soporte
                                            </p>
                                            <button onClick={() => copy(props.data.support_token)} className="rounded-full text-sm w-2/3 text-right button-outline-off copy-cursor">
                                                {props.data.support_token}
                                            </button>
                                        </div>

                                        {props.data.date_created && <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-2/3 text-left">
                                                Fecha Creación
                                            </p>
                                            <p className="rounded-full text-sm w-2/3 text-right">
                                                {formatDate(props.data.date_created)}
                                            </p>
                                        </div>}

                                        {props.data.expiration_date && <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-2/3 text-left">
                                                Fecha Expiración
                                            </p>
                                            <p className="rounded-full text-sm w-2/3 text-right">
                                                {formatDate(props.data.expiration_date)}
                                            </p>
                                        </div>}

                                        {props.data.frozen_date && <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-1/3 text-left">
                                                Fecha Congelado
                                            </p>
                                            <p className="rounded-full text-sm w-2/3 text-right">
                                                {formatDate(props.data.frozen_date)}
                                            </p>
                                        </div>}

                                        {props.data.date_inactive && <div className="flex items-center px-1 leading-7 margin-10px">
                                            <p className="rounded-full mr-4 text-sm w-1/3 text-left">
                                                Fecha Inactivación
                                            </p>
                                            <p className="rounded-full text-sm w-2/3 text-right">
                                                {formatDate(props.data.date_inactive)}
                                            </p>
                                        </div>}
                                    </div>
                                </div>

                                {props.data.card_id && (
                                    <>
                                        <hr />
                                        <div className="justify-center items-center">
                                            <p className="text-center py-4 text-gray-700 text-sm">
                                                Id: {props.data?.card_id}
                                            </p>
                                        </div>
                                    </>
                                )}

                                <div className="items-center justify-end p-2 border-gray-300 rounded-b">
                                    <p className="text-gray-700 text-center text-xs font-hairline"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="fixed inset-0 z-40" style={{
                        background: 'rgba(47, 46, 44, 0.5)',
                        backdropFilter: 'blur(10px)',
                    }}></div>
                </>
            ) : null}
        </>
    );
} 